import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import FixtureCard from '../FixtureCard'
import EmptyState from '../EmptyState'

const UpnextFixtures = ({ data, page }) => {
  // the fixtures
  const edges = data
  const limitDate = edges.filter(
    item =>
      item.node.date === 'Thu 17 Oct' ||
      item.node.date === 'Fri 18 Oct' ||
      item.node.date === 'Sat 19 Oct' ||
      item.node.date === 'Sun 20 Oct'
  )

  // Create a unique list of sports
  const upcomingCount = limitDate.length

  if (upcomingCount === 0) {
    return (
      <EmptyState
        key="upcoming"
        section="upcoming"
        title="Upcoming Markets"
        text="Currently no upcoming markets available"
      />
    )
  }
  return (
    <>
      {limitDate.slice(0, 10).map(({ node }) => {
        if (node.status === 'upcoming') {
          return (
            <FixtureCard
              key={`${node.id}-${node.sport}-${node.start}`}
              fixture={node}
              subheader
              size="small"
            />
          )
        }
        return null
      })}
    </>
  )
}

UpnextFixtures.propTypes = {
  data: PropTypes.array.isRequired,
  page: PropTypes.string,
}

export default UpnextFixtures
